import { all, call, put, takeEvery } from 'redux-saga/effects';
import * as types from './weaveColorActionTypes';
import * as actions from './weaveColorActions';
import * as endpoints from '../../services/endpoints';
import { errorHandler } from '../../helpers/errorHandler';

function* getWeaveColorSaga(action) {
  try {
    const sessionUserId = localStorage.getItem('sessionUserId');
    const payload = { SessionUserId: sessionUserId, ...(action.payload || {}) };
    const { data } = yield call(endpoints.getWeaveColors, payload);
    console.log('data')
    console.log(data)
    yield put(actions.getWeaveColorDataAction(data));
  } catch (e) {
    yield put(actions.getWeaveColorErrorAction(e));
    yield call(errorHandler, e);
  }
}

function* createWeaveColorSaga(action) {
  try {
    const { data } = yield call(endpoints.createWeaveColor, action.payload.data);
    yield put(actions.createWeaveColorDataAction(data));
    if (data.Result?.ErrorCode === 0 && action.payload.navigate) {
      setTimeout(() => action.payload.navigate('/weavecolor'), 1000);
    }
  } catch (e) {
    yield put(actions.createWeaveColorErrorAction(e));
    yield call(errorHandler, e);
  }
}

function* updateWeaveColorSaga(action) {
  try {
    const { data } = yield call(endpoints.updateWeaveColor, action.payload.data);
    yield put(actions.updateWeaveColorDataAction(data));
    if (data.Result?.ErrorCode === 0 && action.payload.navigate) {
      setTimeout(() => action.payload.navigate('/weavecolor'), 1000);
    }
  } catch (e) {
    yield put(actions.updateWeaveColorErrorAction(e));
    yield call(errorHandler, e);
  }
}

function* deleteWeaveColorSaga(action) {
  try {
    const { data } = yield call(endpoints.deleteWeaveColor, action.payload.data);
    yield put(actions.deleteWeaveColorDataAction(data));
    if (data.Result?.ErrorCode === 0) {
      yield put(actions.getWeaveColorRequestAction());
    }
  } catch (e) {
    yield put(actions.deleteWeaveColorErrorAction(e));
    yield call(errorHandler, e);
  }
}

export function* weaveColorSaga() {
  yield all([
    takeEvery(types.GET_WEAVECOLOR_REQUEST, getWeaveColorSaga),
    takeEvery(types.CREATE_WEAVECOLOR_REQUEST, createWeaveColorSaga),
    takeEvery(types.UPDATE_WEAVECOLOR_REQUEST, updateWeaveColorSaga),
    takeEvery(types.DELETE_WEAVECOLOR_REQUEST, deleteWeaveColorSaga),
  ]);
}
